(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/about.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/about.js');
'use strict';

const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  ReactCard: {
    Card,
    CardBody
  },
  ReactIcon,
  Button
} = svs.ui;
const About = () => React.createElement("div", {
  className: "".concat(svs.grassroots.background, " padding-top-2"),
  id: "om-grasroten"
}, React.createElement("div", {
  className: "grassroots-about-container"
}, React.createElement("h1", {
  className: "align-center"
}, svs.grassroots_shared_2.data.config.about.heading.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.about.heading.ingress), React.createElement(Card, {
  branding: svs.grassroots.tenant,
  className: "grassroots-about-points-container padding-1"
}, React.createElement(CardBody, null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
  className: "u-flex u-flex-align-items-center u-flex-justify-content-center grassroots-about-points-left-container",
  sm: "6",
  xs: "12"
}, React.createElement("h2", {
  className: "grassroots-about-contribute-points h1"
}, svs.grassroots_shared_2.data.config.about.card1.left)), React.createElement(GridCol, {
  className: "right",
  sm: "6",
  xs: "12"
}, React.createElement("h2", null, svs.grassroots_shared_2.data.config.about.card1.rightTitle), React.createElement("p", null, svs.grassroots_shared_2.data.config.about.card1.rightText)))))), React.createElement(Card, {
  branding: svs.grassroots.tenant,
  className: "grassroots-about-choose-container margin-top-1 padding-1"
}, React.createElement(CardBody, null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
  className: "grassroots-about-choose-left-container",
  sm: "6",
  xs: "12"
}, React.createElement("h2", null, svs.grassroots_shared_2.data.config.about.card2.leftTitle), React.createElement("p", null, svs.grassroots_shared_2.data.config.about.card2.leftText)), React.createElement(GridCol, {
  className: "u-flex u-flex-align-items-center u-flex-justify-content-center grassroots-about-choose-right-container",
  sm: "6",
  xs: "12"
}, React.createElement(ReactIcon, {
  className: "icon",
  icon: svs.grassroots_shared_2.data.config.about.card2.rightIcon,
  size: "950"
})))))), React.createElement(Card, {
  branding: svs.grassroots.tenant,
  className: "grassroots-about-payment-container margin-top-1 padding-1"
}, React.createElement(CardBody, null, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
  className: "u-flex u-flex-align-items-center u-flex-justify-content-center grassroots-about-payment-container-left-container",
  sm: "6",
  xs: "12"
}, React.createElement(ReactIcon, {
  className: "icon",
  icon: svs.grassroots_shared_2.data.config.about.card3.rightIcon,
  size: "950"
})), React.createElement(GridCol, {
  className: "right",
  sm: "6",
  xs: "12"
}, React.createElement("h2", null, svs.grassroots_shared_2.data.config.about.card3.rightTitle), React.createElement("p", null, svs.grassroots_shared_2.data.config.about.card3.rightText)))))), React.createElement(Card, {
  branding: svs.grassroots.tenant,
  className: "margin-top-1 padding-1",
  id: "anslut"
}, React.createElement(CardBody, {
  className: "margin-bottom-1"
}, React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
  am: "6",
  xs: "12"
}, React.createElement("h2", null, svs.grassroots_shared_2.data.config.about.card4.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.about.card4.text), React.createElement(Button, {
  block: true,
  href: svs.grassroots_shared_2.data.config.about.card4.buttonPath,
  iconPosition: "right",
  inverted: true
}, React.createElement(ReactIcon, {
  icon: "link-external"
}), svs.grassroots_shared_2.data.config.about.card4.buttonText))))))));
svs.grassroots.components.About = About;

 })(window);